export const app = {
  data () {
    return {
      groupViews: ['C','L','P','G','B'],
      buttonText: {
        'C': 'centralny',
        'L': 'lewy bok',
        'P': 'prawy bok',
        'G': 'góra',
        'B': 'z blachą'
      },
      widok: 'C',
      widokBtn: false
    }
  },
  computed: {
    Dystrybutorzy () {
      var listaNazwCentrali = this.getUnique(this.centrale)
      var listaNazwModulu = this.getUnique(this.moduly)
      var results = JSON.parse(JSON.stringify(listaNazwCentrali))

      listaNazwModulu.forEach(element => {
        if (listaNazwCentrali.includes(element)) {
        } else {
          results.push(element)
        }
      });
      // const merge = (listaNazwCentrali, listaNazwModulu, predicate = (a, b) => a === b) => {
      //     const c = [...a]; // copy to avoid side effects
      //     // add all items from B to copy C if they're not already present
      //     b.forEach((bItem) => (c.some((cItem) => predicate(bItem, cItem)) ? null : c.push(bItem)))
      //     return c;
      // }
      return results
    },
    CentraleNazwa () {
      var listaNazwCentrali = this.getUnique(this.centrale)
      return listaNazwCentrali
    },
    centraleLista () {
        let arrNew = this.centrale
      if (this.inputFields.producent) {
        arrNew = Object.values(arrNew).filter(item => item.producent === this.inputFields.producent)
      }
      return arrNew
    },
    ModulyNazwa () {
      var listaNazwModulu = this.getUnique(this.moduly)
      return listaNazwModulu
    },
    modulyLista () {
        let arrNew = this.moduly
      if (this.inputFields.producent) {
        arrNew = Object.values(arrNew).filter(item => item.producent === this.inputFields.producent)
      }
      return arrNew
    },
    checkProjects () {
      if (this.dane) {
        var arr = Object.values(this.dane).filter(item => item.prowadzacy_id === null)
        return arr.length
      }
    }
  },
  methods: {
    getUnique (item) {
      var arr = []
      item.forEach(element => {
        if (arr.includes(element['producent'])) {
        } else {
          arr.push(element['producent'])
        }
      });
      return arr
      // var o = {}, a = [], i, e
      // for (i = 0; e = this[i]; i++) {o[e] = 1}
      // for (e in o) {a.push (e)}
      // return a
     },
     formatFn: function(value) {
      if (value === 1 || value === '1') {
        return 'TAK'
      } else {
        return 'NIE'
      }
    },
    filterParams () {
      // var filtrMontaz = []

      // filtrMontaz = Object.assign({}, this.obudowy);

      // if (this.inputFilters.obudowaMontaz && this.inputFilters.obudowaMontaz.length>0) {
      //   filtrMontaz = Object.values(filtrMontaz).filter(item => this.inputFilters.obudowaMontaz.includes(item.montaz_id))
      // }

      // if (this.inputFilters.obudowaAkumulator && this.inputFilters.obudowaAkumulator.length>0) {
      //   filtrMontaz = Object.values(filtrMontaz).filter(
      //     item => (
      //       this.inputFilters.obudowaAkumulator.includes(String(Number(item.akumulator_1_ah)))) ||
      //       this.inputFilters.obudowaAkumulator.includes(String(Number(item.akumulator_2_ah))) ||
      //       this.inputFilters.obudowaAkumulator.includes(String(Number(item.akumulator_3_ah))) ||
      //       this.inputFilters.obudowaAkumulator.includes(String(Number(item.akumulator_4_ah)))
      //     )
      // }

      // if (this.inputFilters.obudowaTransformator && this.inputFilters.obudowaTransformator.length>0) {
      //   filtrMontaz = Object.values(filtrMontaz).filter(
      //     item => (
      //       this.inputFilters.obudowaTransformator.includes(String(Number(item.transformator_1_ac)))) ||
      //       this.inputFilters.obudowaTransformator.includes(String(Number(item.transformator_2_ac))) ||
      //       this.inputFilters.obudowaTransformator.includes(String(Number(item.transformator_3_ac))) ||
      //       this.inputFilters.obudowaTransformator.includes(String(Number(item.transformator_4_ac)))
      //     )
      // }

      // if (this.inputFilters.obudowaTransformatorMoc && this.inputFilters.obudowaTransformatorMoc.length>0) {
      //   filtrMontaz = Object.values(filtrMontaz).filter(item =>
      //     this.inputFilters.obudowaTransformatorMoc.includes(String(Number(item.transformator_moc))))
      // }

      // this.$store.commit('products/SET_MC_OBUDOWY', filtrMontaz)

      // console.log('filtrMontaz: ', filtrMontaz)

      // grade: null
      // akumulator_1_ah: "7.0000"
      // akumulator_2_ah: null
      // akumulator_3_ah: null
      // akumulator_4_ah:
      // transformator_1_ac: "16.0000"
      // transformator_2_ac: "18.0000"
      // transformator_3_ac: null
      // transformator_4_ac: null
      // transformator_moc: "20.0000"

      // obudowaTransformator: Array(3) [ "14", "18", "20" ]
      // obudowaTransformatorMoc: Array [ "75", "80" ]
      // obudowaMontaz: Array [ "64", "65" ]
      // obudowaAkumulator: Array [ "17" ]

    },
    getImgUrlSystem (pet) {
      // var images = require.context('../assets/img/', false, /\.png$/)
      // var images = require.context('../assets/img/', false, /\.png$/)
      // return images('./' + pet)
    },
    tdClassFunc0 (row) {
      if (row.o0 && row.o0 === '1') {
        return 'rotationYes'
      } else {
        return 'rotationNo'
      }
    },
    tdClassFunc90 (row) {
      if (row.o90 && row.o90 === '1') {
        return 'rotationYes'
      } else {
        return 'rotationNo'
      }
    },
    tdClassFunc180 (row) {
      if (row.o180 && row.o180 === '1') {
        return 'rotationYes'
      } else {
        return 'rotationNo'
      }
    },
    tdClassFunc270 (row) {
      if (row.o270 && row.o270 === '1') {
        return 'rotationYes'
      } else {
        return 'rotationNo'
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/mixins/functions.js